module.exports = __webpack_public_path__ + "assets/img/28@3x.e4e90b18.png";